<template>
  <div
    :class="
      'lightbox__wrapper ' +
        additionalClass +
        (isButtonEnabledState ? ' lightbox__wrapper--enabled' : '')
    "
  >
    <slot> </slot>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  data() {
    return {
      additionalClass: '',
      isButtonEnabledState: false
    };
  },
  computed: {
    lightboxName() {
      return this.$parent.name;
    }
  },
  methods: {
    setFormStep(stepNum) {
      if (this.$parent.setFormStep) {
        this.$parent.setFormStep(stepNum);
      }
    },
    lightboxWrapperButtonClicked() {
      this.isButtonEnabledState = !this.isButtonEnabledState;
    }
  },
  mounted() {
    this.$nextTick(() => {
      $(
        this.$el.querySelectorAll('[data-role="lightbox__wrapper__button"]')
      ).on('click', () => {
        this.lightboxWrapperButtonClicked();
      });
    });
  }
};
</script>
